import get from "lodash.get"
import { PRE_CHECK_MACHINE_STATES } from "../constants"

export function flattenStudentPreCheckState(studentPreChecks){
    if(!studentPreChecks) return {}
    return {
        session_districtId: get(studentPreChecks, 'settings.sessionData.districtId'),
        session_schoolId: get(studentPreChecks, 'settings.sessionData.schoolId'),
        session_sessionId: get(studentPreChecks, 'settings.sessionData.sessionId'),
        session_sessionStartTime: get(studentPreChecks, 'settings.sessionData.sessionStartTime'),
        session_studentId: get(studentPreChecks, 'settings.sessionData.userId'),
        session_grade: get(studentPreChecks, 'settings.sessionData.grade'),
        setting_shouldGoThroughFTUE: get(studentPreChecks, 'settings.shouldGoThroughFTUE'),
        setting_shouldDoAudioChecks: get(studentPreChecks, 'settings.shouldDoAudioChecks'),
        setting_isFullyEnabled: get(studentPreChecks, 'settings.isFullyEnabled'),
        state_currentCheck: get(studentPreChecks, 'currentCheck'),
        state_studentPreCheckFatalExit: get(studentPreChecks, 'studentPreCheckFatalExit'),
        state_studentPreChecksEnded: get(studentPreChecks, 'studentPreChecksEnded'),
        state_studentPreChecksStarted: get(studentPreChecks, 'studentPreChecksStarted'),
    }
}

export function flattenStudentPreCheckContextState(studentPreChecks){
    if(!studentPreChecks) return {}
    const prefix = ''
    return {
        [`${prefix}status_${PRE_CHECK_MACHINE_STATES.networkSpeedChecks}`]: get(studentPreChecks, `contextStates.checks.${PRE_CHECK_MACHINE_STATES.networkSpeedChecks}`),
        [`${prefix}status_${PRE_CHECK_MACHINE_STATES.networkPingChecks}`]: get(studentPreChecks, `contextStates.checks.${PRE_CHECK_MACHINE_STATES.networkPingChecks}`),
        [`${prefix}status_${PRE_CHECK_MACHINE_STATES.hardwareChecks}`]: get(studentPreChecks, `contextStates.checks.${PRE_CHECK_MACHINE_STATES.hardwareChecks}`),
        [`${prefix}status_${PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks}`]: get(studentPreChecks, `contextStates.checks.${PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks}`),
        [`${prefix}status_${PRE_CHECK_MACHINE_STATES.studentASRChecks}`]: get(studentPreChecks, `contextStates.checks.${PRE_CHECK_MACHINE_STATES.studentASRChecks}`),
        [`${prefix}error_${PRE_CHECK_MACHINE_STATES.networkSpeedChecks}`]: get(studentPreChecks, `contextStates.errors.${PRE_CHECK_MACHINE_STATES.networkSpeedChecks}`),
        [`${prefix}error_${PRE_CHECK_MACHINE_STATES.networkPingChecks}`]: get(studentPreChecks, `contextStates.errors.${PRE_CHECK_MACHINE_STATES.networkPingChecks}`),
        [`${prefix}error_${PRE_CHECK_MACHINE_STATES.hardwareChecks}`]: get(studentPreChecks, `contextStates.errors.${PRE_CHECK_MACHINE_STATES.hardwareChecks}`),
        [`${prefix}error_${PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks}`]: get(studentPreChecks, `contextStates.errors.${PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks}`),
        [`${prefix}error_${PRE_CHECK_MACHINE_STATES.studentASRChecks}`]: get(studentPreChecks, `contextStates.errors.${PRE_CHECK_MACHINE_STATES.studentASRChecks}`),
        [`${prefix}troubleshoot_${PRE_CHECK_MACHINE_STATES.networkSpeedChecks}`]: get(studentPreChecks, `contextStates.troubleshootData.${PRE_CHECK_MACHINE_STATES.networkSpeedChecks}`),
        [`${prefix}troubleshoot_${PRE_CHECK_MACHINE_STATES.networkPingChecks}`]: get(studentPreChecks, `contextStates.troubleshootData.${PRE_CHECK_MACHINE_STATES.networkPingChecks}`),
        [`${prefix}troubleshoot_${PRE_CHECK_MACHINE_STATES.hardwareChecks}`]: get(studentPreChecks, `contextStates.troubleshootData.${PRE_CHECK_MACHINE_STATES.hardwareChecks}`),
        [`${prefix}troubleshoot_${PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks}`]: get(studentPreChecks, `contextStates.troubleshootData.${PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks}`),
        [`${prefix}troubleshoot_${PRE_CHECK_MACHINE_STATES.studentASRChecks}`]: get(studentPreChecks, `contextStates.troubleshootData.${PRE_CHECK_MACHINE_STATES.studentASRChecks}`),
        logStack: get(studentPreChecks, `contextStates.logStack`)
    }
}

export function flattenReaderManagerState(readerManagerState, currentCheck){
    if(currentCheck !== PRE_CHECK_MACHINE_STATES.studentASRChecks) return {}
    if(!readerManagerState) return {}
    const { isCurrentStoryEnded, isCurrentStoryStarted, contextStates } = readerManagerState
    const contextKeys = Object.keys(contextStates)
    const flattened = {
        reader_isCurrentStoryEnded: isCurrentStoryEnded,
        reader_isCurrentStoryStarted: isCurrentStoryStarted,
    }
    contextKeys.forEach((key) => {
        flattened[`reader_${key}`] = contextStates[key]
    })
    return flattened
}